// extracted by mini-css-extract-plugin
module.exports = {"graphic":"styles-module--graphic--2ueqe"};